import request from '@/utils/request'

/** 字典类型 */
// 分页查询字典
export function getDictTypePage(params) {
    return request({
        url: '/api/dict/type',
        method: 'get',
        params: params
    })
}

// 新增字典类型
export function saveDictType(params) {
    return request({
        url: '/api/dict/type',
        method: 'post',
        data: params
    })
}

// 编辑字典类型
export function updateDictType(id, params) {
    return request({
        url: '/api/dict/type/' + id,
        method: 'put',
        data: params
    })
}

// 删除字典类型
export function deleteDictType(id) {
    return request({
        url: '/api/dict/type/' + id,
        method: 'delete',
    })
}


/** 字典数据 */
// 根据字典类型查询字典数据树列表
export function getTreeListByDictType(dictType) {
    return request({
        url: '/api/dict/data/public/list/tree',
        method: 'get',
        params: {
            dictType: dictType
        }
    })
}

// 查询字典数据
export function getDictData(params) {
    return request({
        url: '/api/dict/data/public/list/tree',
        method: 'get',
        params: params
    })
}

// 保存字典数据
export function saveDictData(params) {
    return request({
        url: '/api/dict/data',
        method: 'post',
        data: params
    })
}

// 更新字典数据
export function updateDictData(id, params) {
    return request({
        url: '/api/dict/data/' + id,
        method: 'put',
        data: params
    })
}

// 删除字典数据
export function deleteDictData(id) {
    return request({
        url: '/api/dict/data/' + id,
        method: 'delete',
    })
}
